function queryStringToJson(query: string[] | string | undefined) {
  if (typeof query === 'undefined') {
    return {};
  }

  if (typeof query === 'string') {
    return JSON.parse(query);
  }

  return query;
}

export { queryStringToJson };
